module.exports = __webpack_public_path__ + "static/media/reorder.7d1607a9.svg";